import _loadCrazyEgg from '@/vuex/plugins/loaderPlugin/crazyegg.loader'
import _loadGtm from '@/vuex/plugins/loaderPlugin/gtm.loader.plugin'
import _loadGA4 from '@/vuex/plugins/loaderPlugin/ga4.loader'
import _loadMixpanel from '@/vuex/plugins/loaderPlugin/mixpanel.loader'
import _cookieScript from '@/vuex/plugins/loaderPlugin/cookie-script.loader'

const loaderPlugin = (store) => {
  _loadGtm(store)
  _loadCrazyEgg(store)
  _loadGA4(store)
  _loadMixpanel(store)
  // cookieScript have to run the last
  _cookieScript(store)
}

export default loaderPlugin
